import { Box } from '@quintoandar-tokko/jopijs';
import { useSelector } from 'react-redux';
import styles from './pendingEvents.module.scss';
import PendingEventCard from './PendingEventCard';
import { showCardSeparator } from '../utils';

function PendingEventsContainer({ trackCallback = null }) {
  const { items: events } = useSelector((state) => state.DashboardSlice.events);

  return (
    <Box className={styles.pendingEventsContainer}>
      {events.map((event, index) => (
        <Box key={event.id}>
          <PendingEventCard
            isFirst={index === 0}
            hasNow={events.hasNow}
            event={event}
            trackCallback={trackCallback}
          />
          {showCardSeparator(index, events) && (
            <Box className={styles.separator} />
          )}
        </Box>
      ))}
    </Box>
  );
}

export default PendingEventsContainer;
